import React from "react";

export default function Orbs({ variant = "hero" }) {
  if (variant === "hero") {
    return (
      <>
        <div
          className="orb orb-blue"
          style={{ width: 720, height: 720, top: "-180px", left: "-160px" }}
        />
        <div
          className="orb orb-cyan"
          style={{ width: 560, height: 560, top: "10%", right: "-180px" }}
        />
        <div
          className="orb orb-gold"
          style={{ width: 380, height: 380, bottom: "-120px", left: "30%" }}
        />
      </>
    );
  }
  if (variant === "split-left") {
    return (
      <>
        <div
          className="orb orb-blue"
          style={{ width: 540, height: 540, top: "20%", left: "-220px" }}
        />
        <div
          className="orb orb-cyan"
          style={{ width: 360, height: 360, bottom: "-100px", right: "10%" }}
        />
      </>
    );
  }
  if (variant === "split-right") {
    return (
      <>
        <div
          className="orb orb-cyan"
          style={{ width: 520, height: 520, top: "-150px", right: "-180px" }}
        />
        <div
          className="orb orb-blue"
          style={{ width: 420, height: 420, bottom: "-120px", left: "-120px" }}
        />
      </>
    );
  }
  if (variant === "center") {
    return (
      <>
        <div
          className="orb orb-blue"
          style={{
            width: 800,
            height: 800,
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
          }}
        />
        <div
          className="orb orb-cyan"
          style={{
            width: 480,
            height: 480,
            top: "30%",
            left: "10%",
          }}
        />
      </>
    );
  }
  return null;
}
